import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";

export default function Login() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const onLogin = async () => {
    setMsg("");
    const cleanEmail = email.trim().toLowerCase();

    if (!cleanEmail || !password) {
      setMsg("Introduce email y contraseña.");
      return;
    }

    try {
      setLoading(true);

      // Intento normal
      const { error } = await supabase.auth.signInWithPassword({
        email: cleanEmail,
        password,
      });

      // ✅ Pase lo que pase, verificamos sesión
      const {
        data: { session },
      } = await supabase.auth.getSession();

      if (session) {
        nav("/dashboard");
        return;
      }

      // Si no hay sesión, entonces sí: mostramos error real
      if (error) {
        setMsg("Error: " + error.message);
      } else {
        setMsg("No se pudo iniciar sesión.");
      }
    } catch (e) {
      // ✅ Si el TypeError aparece pero hay sesión, entramos igual
      try {
        const {
          data: { session },
        } = await supabase.auth.getSession();
        if (session) {
          nav("/dashboard");
          return;
        }
      } catch (_) {}

      setMsg("Error inesperado: " + (e?.message || String(e)));
    } finally {
      setLoading(false);
    }
  };

  const onGoogle = async () => {
    setMsg("");
    try {
      setLoading(true);

      const { error } = await supabase.auth.signInWithOAuth({
        provider: "google",
        options: {
          redirectTo: `${window.location.origin}/dashboard`,
        },
      });

      if (error) setMsg("Error: " + error.message);
    } catch (e) {
      setMsg("Error inesperado: " + (e?.message || String(e)));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-900 via-purple-800 to-indigo-900 p-6">
      <div className="w-full max-w-md bg-white/10 backdrop-blur-lg border border-white/20 rounded-2xl p-6">
        <h1 className="text-2xl font-bold text-white mb-2">Entrar</h1>

        <input
          className="w-full px-4 py-3 rounded-lg bg-white/10 text-white border border-white/20 focus:outline-none focus:border-yellow-400 mb-3"
          placeholder="tu@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
        />

        <input
          type="password"
          className="w-full px-4 py-3 rounded-lg bg-white/10 text-white border border-white/20 focus:outline-none focus:border-yellow-400"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
        />

        <button
          className="mt-4 w-full bg-yellow-400 text-purple-900 px-4 py-3 rounded-lg font-semibold hover:bg-yellow-300 transition disabled:opacity-60"
          onClick={onLogin}
          disabled={loading}
        >
          {loading ? "Entrando..." : "Entrar"}
        </button>

        <button
          className="mt-3 w-full bg-white text-purple-900 px-4 py-3 rounded-lg font-semibold hover:bg-purple-50 transition disabled:opacity-60"
          onClick={onGoogle}
          disabled={loading}
        >
          Continuar con Google
        </button>

        {msg && <p className="mt-3 text-white text-sm">{msg}</p>}

        <p className="mt-4 text-purple-200 text-sm">
          ¿No tienes cuenta?{" "}
          <Link className="text-yellow-300 underline" to="/signup">
            Crear cuenta
          </Link>
        </p>
      </div>
    </div>
  );
}

